import React, { useState, useEffect } from 'react';
import '../css/ModalConfiguracionHorario.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import ReactDOM from 'react-dom';
import { getPersona } from '../utils/peticionesApi';
import { useMemo } from 'react';

const ModalConfiguracionHorario = ({ onClose }) => {
    const [paso, setPaso] = useState(1);
    const [empleados, setEmpleados] = useState([]);
    const [busqueda, setBusqueda] = useState('');
    const [pagina, setPagina] = useState(1);
    const [porPagina, setPorPagina] = useState(10);

    const [formulario, setFormulario] = useState({
        fechaInicio: '',
        fechaFin: '',
        dias: [],
        entrada: '',
        salida: '',
        descansoInicio: '',
        descansoFin: '',
        empleadosSeleccionados: [],
        sobrescribir: false,
    });

    const diasSemana = ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab'];

    useEffect(() => {
        const fetchEmpleados = async () => {
            try {
                const res = await getPersona();
                const lista = res?.data?.content || res?.data || [];
                const activos = lista.filter(emp => emp.status?.active);
                setEmpleados(activos);
            } catch (err) {
                console.error("Error al cargar empleados:", err);
            }
        };
        fetchEmpleados();
    }, []);

    const toggleDia = (dia) => {
        setFormulario((prev) => ({
            ...prev,
            dias: prev.dias.includes(dia)
                ? prev.dias.filter((d) => d !== dia)
                : [...prev.dias, dia],
        }));
    };

    const handleInputChange = (e) => {
        setFormulario({ ...formulario, [e.target.name]: e.target.value });
    };

    const handleEmpleadoToggle = (id) => {
        setFormulario((prev) => ({
            ...prev,
            empleadosSeleccionados: prev.empleadosSeleccionados.includes(id)
                ? prev.empleadosSeleccionados.filter((eid) => eid !== id)
                : [...prev.empleadosSeleccionados, id],
        }));
    };

    const siguientePaso = () => setPaso(2);

    const confirmar = () => {
        console.log("Datos enviados:", formulario);
        onClose();
    };

    const empleadosFiltrados = useMemo(() => {
        return empleados.filter(emp => {
            const texto = `${emp.person.name} ${emp.person.lastname} ${emp.person.national_id}`.toLowerCase();
            return texto.includes(busqueda.toLowerCase());
        });
    }, [empleados, busqueda]);

    const empleadosPagina = useMemo(() => {
        const start = (pagina - 1) * porPagina;
        return empleadosFiltrados.slice(start, start + porPagina);
    }, [empleadosFiltrados, pagina, porPagina]);

    return ReactDOM.createPortal(
        <div className="modal-overlay">
            <div className="modal-contenido">
                <div className="modal-header">
                    <h3>Configuración rápida</h3>
                    <button className="close-btn" onClick={onClose}>
                        <FontAwesomeIcon icon={faTimes} />
                    </button>
                </div>

                {paso === 1 && (
                    <>
                        <p>Periodo</p>
                        <div className="row-fechas">
                            <div className="campo-fecha-inline">
                                <label>Fecha Inicial<span className="required">*</span></label>
                                <input type="date" name="fechaInicio" value={formulario.fechaInicio} onChange={handleInputChange} />
                            </div>
                            <div className="campo-fecha-inline">
                                <label>Fecha Final<span className="required">*</span></label>
                                <input type="date" name="fechaFin" value={formulario.fechaFin} onChange={handleInputChange} />
                            </div>
                        </div>

                        <div className="dias-semana">
                            {diasSemana.map((dia, index) => (
                                <button
                                    key={index}
                                    className={formulario.dias.includes(dia) ? "dia activo" : "dia"}
                                    onClick={() => toggleDia(dia)}
                                >
                                    {dia}
                                </button>
                            ))}
                        </div>

                        <p className="titulo-bloque">Tiempo de trabajo</p>
                        <hr />
                        <div className="row-horarios">
                            <div className="campo-horario-inline">
                                <label>Entrada<span className="required">*</span></label>
                                <input type="time" name="entrada" value={formulario.entrada} onChange={handleInputChange} />
                            </div>
                            <div className="campo-horario-inline">
                                <label>Salida<span className="required">*</span></label>
                                <input type="time" name="salida" value={formulario.salida} onChange={handleInputChange} />
                            </div>
                        </div>

                        <div className="row-horarios">
                            <div className="campo-horario-inline">
                                <label>Hora Inicio<br />descanso</label>
                                <input type="time" name="descansoInicio" value={formulario.descansoInicio} onChange={handleInputChange} />
                            </div>
                            <div className="campo-horario-inline">
                                <label>Hora Final<br />descanso</label>
                                <input type="time" name="descansoFin" value={formulario.descansoFin} onChange={handleInputChange} />
                            </div>
                        </div>

                        <div className="footer">
                            <button onClick={onClose}>Cancelar</button>
                            <button onClick={siguientePaso}>Siguiente</button>
                        </div>
                    </>
                )}

                {paso === 2 && (
                    <>
                        <div className="empleado-header" style={{ display: 'flex', gap: '1rem', alignItems: 'center', marginBottom: '10px' }}>
                            <input
                                type="text"
                                placeholder="Buscar por nombre o DNI..."
                                value={busqueda}
                                onChange={(e) => {
                                    setBusqueda(e.target.value);
                                    setPagina(1); // reinicia a la página 1 al buscar
                                }}
                                style={{ flex: 1, padding: '6px 10px', border: '1px solid #ccc', borderRadius: '6px' }}
                            />
                            <label style={{ whiteSpace: 'nowrap' }}>
                                <input
                                    type="checkbox"
                                    checked={empleadosFiltrados.length > 0 && empleadosFiltrados.every(e => formulario.empleadosSeleccionados.includes(e.id))}
                                    onChange={() => {
                                        const todosIds = empleadosFiltrados.map(e => e.id);
                                        const yaEstanTodos = todosIds.every(id => formulario.empleadosSeleccionados.includes(id));

                                        setFormulario(prev => ({
                                            ...prev,
                                            empleadosSeleccionados: yaEstanTodos
                                                ? prev.empleadosSeleccionados.filter(id => !todosIds.includes(id))
                                                : [...new Set([...prev.empleadosSeleccionados, ...todosIds])]
                                        }));
                                    }}
                                />
                                Seleccionar todos
                            </label>
                        </div>

                        <div className="tabla-empleados">
                            <table className="tabla-turnos">
                                <thead>
                                    <tr>
                                        <th>
                                            <input
                                                type="checkbox"
                                                checked={empleadosPagina.every(e => formulario.empleadosSeleccionados.includes(e.id))}
                                                onChange={() => {
                                                    const todosIds = empleadosPagina.map(e => e.id);
                                                    const yaEstanTodos = todosIds.every(id => formulario.empleadosSeleccionados.includes(id));

                                                    setFormulario(prev => ({
                                                        ...prev,
                                                        empleadosSeleccionados: yaEstanTodos
                                                            ? prev.empleadosSeleccionados.filter(id => !todosIds.includes(id))
                                                            : [...new Set([...prev.empleadosSeleccionados, ...todosIds])]
                                                    }));
                                                }}
                                            />
                                        </th>
                                        <th>DNI</th>
                                        <th>Nombres</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {empleadosPagina.map((emp) => (
                                        <tr key={emp.id}>
                                            <td>
                                                <input
                                                    type="checkbox"
                                                    checked={formulario.empleadosSeleccionados.includes(emp.id)}
                                                    onChange={() => handleEmpleadoToggle(emp.id)}
                                                />
                                            </td>
                                            <td>{emp.person.national_id}</td>
                                            <td>{emp.person.name} {emp.person.lastname}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>

                            <div className="paginacion-turnos">
                                <span>Total {empleadosFiltrados.length} Registros</span>
                                <button disabled={pagina === 1} onClick={() => setPagina(pagina - 1)}>◀</button>
                                <span>{pagina}</span>
                                <button
                                    disabled={pagina * porPagina >= empleadosFiltrados.length}
                                    onClick={() => setPagina(pagina + 1)}
                                >▶</button>
                                <select value={porPagina} onChange={e => {
                                    setPorPagina(Number(e.target.value));
                                    setPagina(1); // reinicia a página 1 si cambia cantidad
                                }}>
                                    {[5, 10, 20, 50].map(n => (
                                        <option key={n} value={n}>{n}</option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        <div className="footer">
                            <button onClick={onClose}>Cancelar</button>
                            <button onClick={confirmar}>Confirmar</button>
                        </div>
                    </>
                )}

            </div>
        </div>,
        document.body
    );
};

export default ModalConfiguracionHorario;
